declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      REACT_APP_API_URL?: string;
      REACT_APP_GOOGLE_CLIENT_ID?: string;
      REACT_APP_MEDIA_BASE_URL?: string;
    };
  }
}

export function getRuntimeConfigValue(
  key: 'REACT_APP_API_URL' | 'REACT_APP_GOOGLE_CLIENT_ID' | 'REACT_APP_MEDIA_BASE_URL',
) {
  return window.__RUNTIME_CONFIG__?.[key] || process.env[key] || '';
}
